import React from "react";
import "./WhyBlockcode.css";
import discordIcon from "../assets/discord-icon.jpg"; // Sample icons
import stepsIcon from "../assets/steps-icon.png";
import paceIcon from "../assets/pace-icon.png";
import navIcon from "../assets/nav-icon.jpg";
import importIcon from "../assets/import-icon.png";
import trackIcon from "../assets/track-icon.png";
import challengeIcon from "../assets/challenge-icon.jpg";
import celebrateIcon from "../assets/celebrate-icon.png";
import Footer from "../components/Footer";


const features = [
  {
    title: "Simple Navigation",
    description: "Navigate with confidence. Our clean layout makes it easy to find what you need.",
    image: navIcon,
  },
  {
    title: "Discord Access",
    description: "Join the community! Get help, share wins, and vibe with learners like you.",
    image: discordIcon,
  },
  {
    title: "Easy Steps",
    description: "From idea to answer — our block system shows every logical step.",
    image: stepsIcon,
  },
  {
    title: "Learn at Your Pace",
    description: "No timers, no pressure. Learn on your schedule and build confidence.",
    image: paceIcon,
  },
  {
    title: "Import YOUR Problem",
    description: "Paste a prompt, build it with blocks. Your learning, your rules.",
    image: importIcon,
  },
  {
    title: "Track Your Progress",
    description: "Every solved block builds your coding streak and your confidence.",
    image: trackIcon,
  },
  {
    title: "Weekly Challenges",
    description: "Boost your skills with weekly bite-sized challenges to keep sharp.",
    image: challengeIcon,
  },
  {
    title: "Celebrate Success",
    description: "XP, achievements, and milestones that celebrate your journey.",
    image: celebrateIcon,
  },
];

const WhyBlockcode = () => {
    return (
      <div className="why-container">
        <h2 className="why-heading">Why Blockcode?</h2>
  
        <div className="why-static-grid">
          {features.map((feature, index) => (
            <div className="static-card" key={index}>
              <h3>{feature.title}</h3>
              <img src={feature.image} alt={`${feature.title} icon`} />
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
  
        <h2 className="comparison-heading">What Blockcode Offers</h2>
  
        <div className="comparison-chart">
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>Blockcode</th>
                <th>LeetCode</th>
                <th>AlgoExpert</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Beginner Friendly</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Visual Coding</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Step-by-Step Building</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Community Access(Discord)</td>
                <td>✅</td>
                <td>Limited</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Import Your Own Problems</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Monthly Dev Q&A</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Daily Challenges</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
              <tr>
                <td>Earn Experience with Rewards</td>
                <td>✅</td>
                <td>❌</td>
                <td>❌</td>
              </tr>
            </tbody>
          </table>
          
        </div>
        <Footer />

      </div>
    );
  };
  
  export default WhyBlockcode;